import {useQuery} from '@tanstack/react-query';
import {useRequiredTenantId} from '@/matic/hooks/useRequiredTenantId';
import {getMasterDataApi} from '../api/master-data-api';
import {masterDataKeys} from '../query-keys';
import type {ObjectType} from '../types/master-data-types';

export function useObjectType(typeId?: string) {
  const tenantId = useRequiredTenantId();
  const api = getMasterDataApi();

  return useQuery<ObjectType>({
    queryKey: masterDataKeys.objectType(typeId ?? '', tenantId),
    queryFn: async () => api.getObjectType(typeId!),
    enabled: Boolean(typeId),
  });
}
